import { Radio } from '@mui/material';
import { NumberInput } from './NumberInput';
import styled from '@emotion/styled';

interface RadioButtonNumberInputInterface {
  value: number | undefined;
  setValue(val: number | undefined): void;
  label: string;
  marginRight?: number;
  checked: boolean;
  metric: string;
  setActiveRadio(): void;
  conversionType: string;
  step?: string;
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const Label = styled.div`
  min-width: 120px;
  font-size: 14px;
  line-height: 16px;
  font-weight: 500;
`;

export const RadioButtonNumberInput = ({
  value,
  setValue,
  label,
  checked,
  metric,
  conversionType,
  setActiveRadio,
  step,
}: RadioButtonNumberInputInterface) => {
  return (
    <Wrapper>
      <Radio
        size='small'
        checked={checked}
        onChange={() => setActiveRadio()}
        color='info'
      />
      <Label>{label}</Label>
      <NumberInput
        value={value}
        conversionType={conversionType}
        setValue={(val) => setValue(val)}
        label={`[${metric}]`}
        disabled={!checked}
        step={step}
      />
    </Wrapper>
  );
};
